import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../services/AuthService/auth';
import { ApiEnvelope } from '../../models/auth.dto';

@Component({
  selector: 'app-login',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login {
  email = '';
  password = '';
  isSubmitting = signal(false);
  errorMessage = signal('');
  showPassword = signal(false);

  constructor(private auth: AuthService, private router: Router) {}

  togglePasswordVisibility(): void {
    this.showPassword.update((v) => !v);
  }

  submit(): void {
    this.errorMessage.set('');
    this.isSubmitting.set(true);

    this.auth.login(this.email, this.password).subscribe({
      next: () => {
        this.isSubmitting.set(false);
        this.router.navigate(['/']);
      },
      error: (err: HttpErrorResponse) => {
        this.isSubmitting.set(false);
        const body = err.error as ApiEnvelope<unknown> | undefined;
        this.errorMessage.set(body?.message ?? 'Login failed. Please try again.');
      },
    });
  }
}
